import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { createQuizz, updateQuizz } from '../../../../actions/quizz.js';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';

const options = {
    validate : false,
    multipleChoice : false,
    numberOfChoices : 1
}

function Quizz({match, initial = {tags : [], options}, isEditing = false, afterSubmit}) {

  const dispatch = useDispatch()
  const [currentStep, setCurrentStep] = useState(1);
  const [quizz, setQuizz] = useState(initial);

  useEffect(() => {
    // Si dans articleData.tags on a un ID qui n'est plus dans match.tags, on le retire de articleData
    const newTags = quizz.tags ? quizz.tags.filter(t => match.tags.find(tag => tag._id === t)) : []

    setQuizz(s => ({...s, tags : newTags}))

  }, [match.tags])

  const handleStep1Submit = (formData) => {
    setQuizz({ ...quizz, ...formData});
    setCurrentStep(2);
  };

  const handleStep2Submit = (formData) => {
    setQuizz({ ...quizz, ...formData });
    setCurrentStep(3);
  };

  const handleStep3Submit = (formData) => {
    setQuizz({ ...quizz, ...formData });
    setCurrentStep(4);
  };

  const handleStep4Submit = () => {

    if(isValidQuizz(quizz)){
      // Dispatch du sondage
      isEditing ? dispatch(updateQuizz(quizz, quizz._id)) : dispatch(createQuizz(quizz, match))
      setQuizz({options})
      setCurrentStep(1)

      afterSubmit && afterSubmit()
    }
  };

  const isValidQuizz = (quizz) => {
    return true
  }

  const handleStepBack = () => {
    setCurrentStep(currentStep - 1);
  };

  return (
    <>
      {currentStep === 1 && (
        <Step1
          quizz={quizz}
          questions={[]}
          onSubmit={handleStep1Submit}
        />
      )}
      {currentStep === 2 && (
        <Step2
          match={match}
          questions={[]}
          onSubmit={handleStep2Submit}
          onBack={handleStepBack}
          quizz={quizz}
        />
      )}
      {currentStep === 3 && (
        <Step3
          questions={[]}
          onSubmit={handleStep3Submit}
          onBack={handleStepBack}
          quizz={quizz}
          
        />
      )}
      {currentStep === 4 && (
        <Step4
          match={match}
          onSubmit={handleStep4Submit}
          onBack={handleStepBack}
          quizz={quizz}
          setQuizz={setQuizz}
        />
      )}
    </>
  );
}

export default Quizz;